import * as FormUtils from './form-utils';
import Slideable from '../classes/slideable';
import flatpickr from "flatpickr";
import easydropdown from 'easydropdown';
import { German } from "flatpickr/dist/l10n/de.js"

const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * FORM.JS
 *
 * Initialization of the validation of a generic form.
 */
 export default function InitForms() {
	// init flatpickr
	document.querySelectorAll('input[type="date"]').forEach((input) => {
		const date = input.getAttribute('value');
		const datePicker = flatpickr(input, {
			locale: German,
			maxDate: new Date(),
			dateFormat: 'd.m.Y',
			disableMobile: true
		});
		datePicker.setDate(date);
	});

	// init easy dropdown and destroy all instances inside flatpickr
	easydropdown.all();
	const flatpickrInstances = document.querySelectorAll('.flatpickr-calendar select');
	flatpickrInstances.forEach((select) => {
		const edd = easydropdown(select);
		edd.destroy();
	});

	const forms = document.querySelectorAll('form.generic-form');
	forms.forEach((form) => {
		InitForm(form);
		InitArrayFieldtype(form);
	});
}

function InitForm(form) {
	if (!form)
		return;

	const successText = form.querySelector('.success-message');
	const errorText = form.querySelector('.error-message');
	const buttonSubmit = form.querySelector('.button-submit');
	const redirectUriInput = form.querySelector('input[name="redirect_uri"]');
	const cacheValues = form.querySelector('input[name="cache_values"]');
	const shouldCacheValues = cacheValues && cacheValues.value == 'true';
	const formHandle = form.getAttribute('data-handle');
	let shouldRedirect = redirectUriInput && redirectUriInput.value != null;
	let loadingSpinner = buttonSubmit ? buttonSubmit.querySelector('.animate-spin') : null;

	InitFileInputs(form);

	if(shouldCacheValues)
		FormUtils.FillWithSessionData(form);

	form.addEventListener('submit', (event) => {
		event.preventDefault();

		if(loadingSpinner)
			loadingSpinner.classList.remove('hidden');

		axios.post(form.action, new FormData(form))
			.then(() => {
				const event = new CustomEvent("form-success", { cancelable: true, detail: { formHandle: formHandle } } );

				errorText.classList.add('hidden');
				successText.classList.remove('hidden');
				FormUtils.HideErrorFields(form);

				if(window.dispatchEvent(event)) { 
					if (shouldRedirect)
						window.location.href = redirectUriInput.value;
					else {
						if(loadingSpinner)
							loadingSpinner.classList.add('hidden');
						FormUtils.ClearAllFields(form);
					}
				}
			})
			.catch((error) => {
				const event = new CustomEvent("form-error", { cancelable: true, detail: { formHandle: formHandle, error: error } });
				window.dispatchEvent(event);
				
				if(loadingSpinner)
					loadingSpinner.classList.add('hidden');
				successText.classList.add('hidden');

				FormUtils.HideErrorFields(form);

				if (error.response) {
					// Request made and server responded
					if (error.response.data && error.response.data.error && error.response.status == 400)
						FormUtils.HandleFormErrors(form, error.response.data.error);
					else errorText.classList.remove('hidden');

				} else if (error.request) {
					// The request was made but no response was received
					console.log(error.request);
					errorText.classList.remove('hidden');
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
					errorText.classList.remove('hidden');
				}
			});
	});
}

function InitFileInputs(form) {
	const fileInputs = form.querySelectorAll('input[type="file"]');

	fileInputs.forEach(input => {
		input.onchange = function () {
			const id = input.id;

			let fileName = input.files.length + ' File(s)';
			switch (input.files.length) {
				case 0:
					fileName = '';
					break;
				case 1:
					fileName = input.files[0].name;
					break;
			}

			const imageElement = document.querySelector('.uploaded-image[data-input="' + id + '"]');
			const fileNameElement = document.querySelector('.file-name[data-input="' + id + '"]');

			if (imageElement) {
				if (input.files && input.files[0]) {
					var reader = new FileReader();
					reader.onload = (e) => {
						imageElement.style.backgroundImage = 'url(' + e.target.result + ')';
					};
					reader.readAsDataURL(input.files[0]);
				} else {
					imageElement.style.backgroundImage = null;
				}
			} else fileNameElement.innerHTML = fileName;
		};
	});
}

function InitArrayFieldtype(form) {
	const extensionButtons = form.querySelectorAll('.extend-array');
	const arrayElements = form.querySelectorAll('.array-element');

	if (!extensionButtons)
		return;

	extensionButtons.forEach((button) => {
		button.addEventListener('click', () => {
			let handle = button.getAttribute('data-handle');
			let grid = form.querySelector('.form-field.' + handle);

			let arrayElements = grid.querySelectorAll('.array-element[data-handle="' + handle + '"]');
			let extensionWrapper = grid.querySelector('.extension-wrapper');
			let newElement = arrayElements[0].cloneNode(true);

			let inputs = newElement.querySelectorAll('input');
			inputs.forEach((input) => {
				let name = input.getAttribute('name');
				name = name.replace(handle + '[0]', handle + '[' + arrayElements.length + ']');
				input.setAttribute('name', name);
			});

			newElement.style.display = 'none';
			FormUtils.ClearAllFields(newElement);
			form.querySelector('.form-field.' + handle).insertBefore(newElement, extensionWrapper);

			let slideable = new Slideable(newElement);
			slideable.up();

			initButtonRemove(newElement);
		});
	});

	let initButtonRemove = function (arrayElement) {
		let buttonRemove = arrayElement.querySelector('.remove');
		let slideable = new Slideable(arrayElement);
		buttonRemove.addEventListener('click', () => {
			slideable.down();
			setTimeout(() => {
				arrayElement.remove();
			}, 1000);
		});
	};

	if (!arrayElements)
		return;

	arrayElements.forEach((arrayElement) => {
		initButtonRemove(arrayElement);
	});
}